<div class="c-auth">
  <div class="c-auth__wrapper c-auth__wrapper--wide">
    <div class="warning__top">
      <img
        src="assets/img/logos/lightspeed-vertical.png"
        class="c-auth__brand"
        alt="Lightspeed"
      />
      <div class="warning__language u-align-center">
        <!-- TODO: Add active class to link -->
        <a href="{{ getUrl('nl-BE') }}">NL</a>
        <span>|</span>
        <a href="{{ getUrl('fr-BE') }}">FR</a>
        <span>|</span>
        <a href="{{ getUrl('en-US') }}">EN</a>
      </div>
    </div>
    <div class="c-auth__form">
      <div class="warning__content">
        <div class="warning__image">
          <img
            src="assets/img/visuals/visual-warning.png"
            alt="Update Required"
          />
          <h6
            class="u-align-center"
            i18n="UPDATE_WARNING|Label under warning icon @@warningLabelUpdateRequired"
          >
            Update Required
          </h6>
        </div>
        <div class="warning__error">
          <p class="u-align-left">
            <span
              i18n="UPDATE_WARNING|Message to update their app @@warningMessageUpdateRequired"
              >Due to your outdated app version, the “Manage my Restaurant”
              functionality is currently blocked. Please update your device to
              the latest app version to continue.</span
            >
            <br /><br />
            <span
              i18n="UPDATE_WARNING|Link to Lightspeed support when having problems @@warningLinkUpdateRequired"
              >If problems persist, please
              <a
                href="https://www.lightspeedhq.com/support/restaurant/"
                target="_blank"
                >contact Lightspeed Support</a
              >.</span
            >
          </p>
          <a
            href="https://resto-support.lightspeedhq.com/hc/en-us/articles/115003931328-Updating-Restaurant-POS"
            target="_blank"
            class="o-button o-button--medium o-button--default"
            i18n="UPDATE_WARNING|Link to support on how to update the app @@linkHowToUpdate"
            >How to update?</a
          >
          <a
            href="https://support.apple.com/en-us/HT201487"
            target="_blank"
            class="o-button o-button--medium o-button--default"
            i18n="UPDATE_WARNING|Link to apple on how to reset your apple id @@linkResetAppleId"
            >How to reset Apple ID?</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
